import { ErrorCode } from "@/gql/graphql";
import { ApolloError } from "@apollo/client";

export default class GqlService {
  static isErrorCode(err: Error, code: ErrorCode) {
    if (GqlService.isApolloError(err)) {
      return err.graphQLErrors.some((e) => e.extensions?.code === code);
    }
    return false;
  }

  static isApolloError(err: Error): err is ApolloError {
    return (err as ApolloError).graphQLErrors !== undefined;
  }
}
